import { render, staticRenderFns } from "./TextModule.vue?vue&type=template&id=a2e611a4&"
import script from "./TextModule.vue?vue&type=script&lang=js&"
export * from "./TextModule.vue?vue&type=script&lang=js&"
import style0 from "./TextModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports